// extracted by mini-css-extract-plugin
export default {"container":"components-general-smart-insights-upsell-accordion-year-view-module__container"};